module.exports = __webpack_public_path__ + "img/icon-user.850792ba.svg";